export default __webpack_public_path__ + "static/media/location-icon.74d3b2a6.svg";